<template>
  <div class="login">
    <div class="login_box">
      <div class="icon_box">
        <div class="icon_img_box"></div>
      </div>
      <!-- 登录区域 -->
      <el-form ref="loginFormRef" class="login_form" label-width="0px;" :model="loginForm" :rules="loginFromRoules">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-s-custom" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" prefix-icon="el-icon-lock" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitStatus" type="primary" @click="login">登陸</el-button>
        </el-form-item>
      </el-form>
      <el-row class="copyright">
        <p>Copy right © TECHTOP Ltd 2020. All rights reserved</p>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      submitStatus: false,
      loginForm: {
        username: "",
        password: ""
      },
      loginFromRoules: {
        // 验证码用户名是否合法
        username: [
          { required: true, message: "請輸入登陸名稱", trigger: "blur" },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "請輸入密碼", trigger: "blur" },
        ]
      }
    };
  },
  mounted () {
    // 绑定enter事件
    this.enterKeyup();
  },
  destroyed () {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  methods: {
    enterKey (event) {
      const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
      if (code == 13) {
        this.login();
      }
    },
    enterKeyupDestroyed () {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup () {
      document.addEventListener("keyup", this.enterKey);
    },
    // 表单数据提交
    login () {
      // 表单提交数据前验证 valid为验证结果，验证通过为true
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return;
        this.submitStatus = true;
        let pwd = this.loginForm.password.trim();
        let requestData = {
          username: this.loginForm.username.trim(),
          password: this.pwdencode(pwd),
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // console.log(requestData);
        this.post('/api/auth/login', requestData)
          .then(response => {
            // console.log(response);
            // return false;
            if (response.status == 'success') {
              // 重置登錄表單
              this.$refs['loginFormRef'].resetFields();
              // 本地化存储用户名、token和MSO_Id
              let userInfo = response.user;

              // sessionStorage.setItem('version', response.version);
              sessionStorage.setItem('user_id', userInfo.id);
              sessionStorage.setItem('mso_id', userInfo.mso_id);
              sessionStorage.setItem('token', userInfo.token);
              sessionStorage.setItem('username', userInfo.username);
              sessionStorage.setItem('thumb', userInfo.thumb);
              sessionStorage.setItem('examine_status', this.pwdencode(userInfo.username+userInfo.mso[0]['examine_status']));
              sessionStorage.setItem('mso_list', JSON.stringify(userInfo.mso));
              sessionStorage.setItem('staff_id', userInfo.id);

              // 提醒信息
              this.$notify({
                message: '登錄成功',
                type: 'success',
                duration: 3000,
                offset: 70
              });

              this.$router.push({
                path: '/'
              })
            } else {
              this.$notify({
                message: 'Login Error',
                type: 'error',
                duration: 3000,
                offset: 70
              });
            }
            loading.close();
            this.submitStatus = false
          }).catch(error => {
            console.log(error);
            loading.close();
            this.submitStatus = false
          });

      });
    }
  }
};
</script>

<style  scoped>
.login {
  background-color: #344a5f;
  height: 100vh;
}

.login_box {
  width: 400px;
  height: 280px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.icon_box {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 0 10px #ddd;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}

.icon_img_box {
  box-sizing: border-box;
  border: 1px solid #eeffee;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-image: url('../../assets/logo.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

button {
  width: 100%;
}

.login_form {
  position: absolute;
  width: 100%;
  padding: 60px 20px;
  box-sizing: border-box;
}
.copyright {
  position: absolute;
  bottom: -65px;
  width: 100%;
  color: #fff;
  text-align: center;
}
@media (max-width: 480px) {
  .login_box {
    width: 300px;
    height: 250px;
    background-color: #fff;
    border-radius: 3px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
